import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { useQuery } from 'react-query';
import { useQueryParams } from 'use-query-params';

import { filterParams } from './constants';
import { RealtorContractType } from './models';

export function useRealtorContracts() {
  const [query] = useQueryParams(filterParams);

  const { data, ...arg } = useQuery<{
    contracts: RealtorContractType[];
    totalPages: number;
    currentPage: number;
    totalElements: number;
  }>(['realtor-contracts', query], async () => {
    const { data } = await $api.post('v1/realtor-contract/filter', query);

    const totalPages = data?.data?.totalPages || 0;
    const currentPage = data?.data?.currentPage || 1;
    const totalElements = data?.data?.totalElements || 0;

    const contracts: RealtorContractType[] = data?.data?.data;

    return {
      contracts: contracts
        ? contracts?.map(item => ({
            ...item,
            createdDate: timeStampToDate({ date: item?.createdDate, timeStamp: item?.createdTimestamp })
          }))
        : contracts,
      totalPages,
      currentPage,
      totalElements
    };
  });

  return { ...arg, ...data };
}
